export const CONTACT = {
  phone: "01483 920866",
  phoneHref: "tel:01483920866",
  email: "info@cedarviews.co.uk",
  address: ["Unit E5B", "Fairoaks Airport", "Chobham", "GU24 8HU"],
  hours: "Monday to Friday · 08:00 – 17:00",
  rating: "4.7",
  reviews: "53",
};

export const LOCATIONS = [
  {
    id: "chobham",
    name: "Flagship Showroom",
    place: "Fairoaks Airport, Chobham",
    address: ["Unit E5B", "Fairoaks Airport", "Chobham", "GU24 8HU"],
    desc: "Our full windows and doors showroom. Walk working displays of sliding, bifold and front doors and windows from every brand we partner with.",
    img: "/images/showroom-hero.jpg",
    hours: "Monday to Friday · 08:00 – 17:00",
  },
  {
    id: "longacres",
    name: "Glazing Studio",
    place: "Longacres Garden Centre, Bagshot",
    address: ["Longacres Garden Centre", "London Road", "Bagshot", "GU19 5JB"],
    desc: "Our brand-new architectural glazing studio. Drop in while you shop, or book an appointment to discuss your project with the team.",
    img: "https://customer-assets-39nsmqrw.emergentagent.net/job_glazing-premium-ux/artifacts/kj8phfw7_AHRPTWkpxm32KvtmIO47jqrYYnPz4LK7Af_km_5NZvl1_76sTcvrNyiMT4kahFJF2K9lrV7DUwonv1-5OedNeEWSPb0pkWZ2xuNSk0lrvr3iiZdyXvTAePrQldnDoDAa6t15VJH7pLzqgfBHSOj7%3Ds1360-w1360-h1020.jpeg",
    hours: "Open 7 days · garden centre hours",
  },
];

export const IMG = {
  clandon: "/files/obgImage-8337.png",
  kingswood: "/entrance-doors/kobbe-doors/files/obgImage-820.jpg",
  guildford: "/residence-collection/residence-7/files/obgImage-721.jpg",
  sunflexSvg30: "/sunflex-uk/files/small-1401.jpg",
  residence: "/residence-collection/files/obgImage-853.jpg",
  originSoho: "/origin/files/small-708.jpg",
  fortisHero: "/entrance-doors/fortis-aluminium-doors/files/small-1431.jpg",
  fortisD72: "/entrance-doors/fortis-aluminium-doors/files/small-1431.jpg",
  fortisPivot: "/entrance-doors/fortis-aluminium-doors/files/small-1430.png",
  fortisDetail: "/entrance-doors/fortis-aluminium-doors/files/small-708.jpg",
  fortisAlt: "/entrance-doors/fortis-aluminium-doors/files/small-1210.jpg",
  originBifold: "/origin/files/small-1348.jpg",
  originInternal: "/origin/files/small-1401.jpg",
  originFront: "/origin/files/small-1566.jpg",
  originWindows: "/origin/files/small-1554.jpg",
  camberley: "/entrance-doors/fortis-aluminium-doors/files/small-708.jpg",
  fleet: "/files/obgImage-8189.jpg",
};

export const BRAND_LOGOS = [
  { name: "Fortis", src: "/logos/fortis.png" },
  { name: "Rationel", src: "/logos/rationel.png" },
  { name: "Origin", src: "/logos/origin.png" },
  { name: "Sunflex UK", src: "/logos/sunflex.png" },
  { name: "Velfac", src: "/logos/velfac.png" },
  { name: "Liniar", src: "/logos/liniar.png" },
];

export const TESTIMONIALS = [
  {
    quote:
      "We are very happy with our new front door. It looks fantastic and has changed the look of the house completely. The quality is excellent, it was definitely worth going to the Fairoaks Airport showroom to see the products before you order.",
    name: "Lorraine Toogood",
    place: "Yateley",
  },
  {
    quote:
      "Everything was brilliant from the online quote to Wayne coming round to measure up. There was quite a lot of building work to do around the door and all the traders were brilliant. We could not be happier and would strongly recommend Cedar Views.",
    name: "Mike Hanson",
    place: "Farnham",
  },
  {
    quote:
      "Throughout the process they were clear on when they were coming, how long it would take and how much it would cost. What made the service better than most: they popped round a year later to adjust a different door, without charge. I would definitely use them again.",
    name: "Nick Harvey",
    place: "Chobham",
  },
];

export const PROJECTS = [
  {
    title: "Luxury Origin Windows & Doors, Clandon",
    location: "Clandon, Surrey",
    spec: "Origin OW80, OB-49 & Fortis entrance door",
    image: IMG.clandon,
    body: "A complete fenestration package for a substantial Surrey home, Origin's flagship OW80 window suite paired with OB-49 bifolding doors and a handcrafted Fortis entrance door, installed by our in-house team.",
  },
  {
    title: "Premium Aluminium Installation, Kingswood",
    location: "Kingswood, Surrey",
    spec: "Origin OW70 & OS-29 with Kobbe entrance door",
    image: IMG.kingswood,
    body: "Slim-sightline Origin OW70 windows and an OS-29 sliding door open this Kingswood property to its garden, finished with a striking Kobbe entrance door as the centrepiece of the façade.",
  },
  {
    title: "Residence 7 Windows & French Doors, Guildford",
    location: "Guildford, Surrey",
    spec: "Residence 7 in Painswick finish",
    image: IMG.guildford,
    body: "Heritage character with modern performance, flush Residence 7 windows and French doors in a soft Painswick finish, sympathetically installed against traditional Surrey brickwork.",
  },
];

export const NAV = {
  windows: [
    { label: "Aluminium Windows", to: "/aluminium-windows/", desc: "Slim sightlines, engineered to last" },
    { label: "Origin Windows", to: "/windows/aluminium-windows/origin-windows/", desc: "OW-70 Slimline & OW-80 Premium" },
    { label: "uPVC Windows", to: "/upvc-windows/", desc: "A-rated Liniar systems" },
    { label: "Residence Collection", to: "/residence-collection/", desc: "Timber charm, modern performance" },
    { label: "Roof Windows", to: "/roof-windows/", desc: "Rooflights & lanterns" },
    { label: "Heritage Crittall Replacement", to: "/heritage-crittal-replacement-windows/", desc: "Steel-look, modern performance" },
    { label: "Velfac Windows", to: "/velfac-windows-surrey/", desc: "Danish composite glazing" },
    { label: "Rationel Windows", to: "/rationel-windows/", desc: "Timber / aluminium hybrid" },
  ],
  doors: [
    { label: "Entrance Doors", to: "/entrance-doors/", desc: "First impressions, engineered" },
    { label: "Fortis Aluminium Doors", to: "/entrance-doors/fortis-aluminium-doors/", desc: "Handcrafted in Britain" },
    { label: "Sliding Doors", to: "/sliding-doors/", desc: "Uninterrupted views" },
    { label: "Bifold Doors", to: "/bifold-doors/", desc: "Open your home to the garden" },
    { label: "Origin Bifold Doors", to: "/doors/bifold-doors/origin-bifold-doors/", desc: "Soho & Contemporary collections" },
    { label: "Internal Doors", to: "/doors/internal-doors/", desc: "Origin internal glazing" },
    { label: "Art Deco Doors", to: "/art-deco-doors/", desc: "Statement heritage design" },
  ],
  brands: [
    { label: "Cortizo", to: "/cortizo-bi-fold/", desc: "Minimal frames, maximum glass" },
    { label: "Endurance", to: "/entrance-doors/composite-front-doors/", desc: "Solid composite doors" },
    { label: "Fortis", to: "/entrance-doors/fortis-aluminium-doors/", desc: "Handcrafted in Britain" },
    { label: "Kobbe", to: "/entrance-doors/kobbe-doors/", desc: "Bold, striking entrances" },
    { label: "Liniar", to: "/upvc-windows/", desc: "A-rated uPVC systems" },
    { label: "Origin", to: "/origin/", desc: "The full Origin range" },
    { label: "Rationel", to: "/rationel-windows/", desc: "Scandinavian precision" },
    { label: "Residence", to: "/residence-collection/", desc: "Heritage flush windows" },
    { label: "Smarts", to: "/sliding-doors/", desc: "British-designed aluminium" },
    { label: "Sunflex UK", to: "/sunflex-uk/", desc: "German-engineered systems" },
    { label: "Velfac", to: "/velfac-windows-surrey/", desc: "Wood inside, aluminium outside" },
  ],
  professionals: [
    { label: "Architects", to: "/architects/", desc: "Specification & technical support" },
    { label: "Developers", to: "/developers/", desc: "Reliable multi-plot delivery" },
    { label: "Quantity Surveyors", to: "/quantity-surveyors/", desc: "Accurate costing & packages" },
  ],
};

// ---- Site-wide editable content (defaults; overridden in place by /api/site-content via lib/siteContent.js) ----
export const BRAND = {
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_glazing-premium-ux/artifacts/2xahq1b9_Cedar%20Views%20Logo%202.png",
  tagline: "Serving Surrey and Hampshire with premium windows and doors",
  bookLabel: "Book Showroom",
};

export const FOOTER = {
  blurb: "Premium windows and doors, supplied and installed across Surrey and Hampshire. FENSA registered, with over 200 years of combined building and fenestration expertise within the Cedar group.",
  copyright: "Cedar Views. All rights reserved. FENSA registered installer.",
  company: [
    { label: "Project Portfolio", to: "/projects/" },
    { label: "Testimonials", to: "/testimonials/" },
    { label: "Our Showrooms", to: "/showroom/" },
    { label: "Building Services", to: "/building-services/" },
    { label: "Areas We Cover", to: "/areas/" },
    { label: "Architects", to: "/architects/" },
    { label: "Developers", to: "/developers/" },
    { label: "Quantity Surveyors", to: "/quantity-surveyors/" },
    { label: "Contact Us", to: "/contact/" },
    { label: "Privacy Policy", to: "/privacy-policy/" },
  ],
};

export const CTA = {
  overline: "Start your project",
  headingLines: ["Let's talk about", "your home."],
  text: "Visit our flagship showroom at Fairoaks Airport, Chobham, or request a free, no-obligation quotation. Our team will guide you from first sketch to final installation.",
  showroomLabel: "Visit the showroom",
};

export const HOME = {
  heroOverline: "Chobham · Surrey · Hampshire · FENSA registered",
  heroLines: ["A clear choice", "for quality."],
  heroSub: "Premium aluminium windows and doors from Origin, Velfac, Cortizo, Sunflex and Fortis. Designed, supplied and installed by one accountable team.",
  heroPoster: IMG.clandon,
  heroPrimary: { label: "Request a free quote", to: "/contact/" },
  heroSecondary: { label: "View our projects", to: "/projects/" },
  collectionKicker: "The collection",
  collectionTitle: "Windows, doors and everything in between.",
  tiles: [
    { label: "Aluminium Windows", to: "/windows/aluminium-windows/", img: "/files/obgImage-8222.jpg", span: "lg:col-span-7", h: "lg:min-h-[420px]", tag: "Windows", d: "Slim sightlines from Origin, Smarts, ALUK, Rationel & VELFAC" },
    { label: "Origin Windows & Doors", to: "/origin/", img: "/files/obgImage-8233.jpg", span: "lg:col-span-5", h: "lg:min-h-[420px]", tag: "Brand partner", d: "The full Origin range, manufactured in Britain" },
    { label: "Sliding Doors", to: "/doors/sliding-doors/", img: "/files/obgImage-8189.jpg", span: "lg:col-span-4", tag: "Doors", d: "Cortizo, Origin, Sunflex & Smarts" },
    { label: "Sunflex UK", to: "/sunflex-uk/", img: "/files/obgImage-8244.jpg", span: "lg:col-span-4", tag: "Brand partner", d: "Award-winning bifold and sliding systems" },
    { label: "Velfac Windows", to: "/velfac-windows-surrey/", img: "/files/obgImage-8309.jpg", span: "lg:col-span-4", tag: "Brand partner", d: "Danish composite, warm wood inside, aluminium outside" },
    { label: "Fortis Doors", to: "/entrance-doors/fortis-aluminium-doors/", img: "/files/obgImage-8337.png", span: "lg:col-span-5", h: "lg:min-h-[400px]", tag: "Entrance doors", d: "Bespoke aluminium front doors, made in Britain" },
    { label: "Bifold Doors", to: "/doors/bifold-doors/", img: "/origin/files/small-1348.jpg", span: "lg:col-span-7", h: "lg:min-h-[400px]", tag: "Doors", d: "Open your home to the garden" },
    { label: "Residence Collection", to: "/residence-collection/", img: "/files/obgImage-8348.jpg", span: "lg:col-span-4", tag: "Windows", d: "Timber charm, modern performance" },
    { label: "uPVC Windows", to: "/windows/upvc-windows/", img: "/windows/upvc-windows/files/obgImage-294.jpg", span: "lg:col-span-4", tag: "Windows", d: "A-rated Liniar systems, casement, flush & Resurgence" },
    { label: "Rationel Windows", to: "/rationel-windows/", img: "/files/obgImage-8255.jpg", span: "lg:col-span-4", tag: "Brand partner", d: "Danish low-energy windows and doors" },
    { label: "Internal Doors", to: "/doors/internal-doors/", img: "/files/obgImage-8167.jpg", span: "lg:col-span-5", h: "lg:min-h-[400px]", tag: "Doors", d: "Origin internal glazing and room dividers" },
    { label: "Entrance Doors", to: "/entrance-doors/", img: "/entrance-doors/fortis-aluminium-doors/files/small-1431.jpg", span: "lg:col-span-7", h: "lg:min-h-[400px]", tag: "Doors", d: "Fortis, Kobbe, Origin & Endurance composite" },
    { label: "Building Services", to: "/building-services/", img: "/images/bs/hero.jpg", span: "lg:col-span-7", h: "lg:min-h-[400px]", tag: "Beyond glazing", d: "Extensions, orangeries, garden rooms & conservatory conversions" },
    { label: "Roof Windows & Lanterns", to: "/roof-windows/", img: "/images/roof-lantern.jpg", span: "lg:col-span-5", h: "lg:min-h-[400px]", tag: "Windows", d: "Rooflights and lanterns that let the light in" },
    { label: "Our Showrooms", to: "/showroom/", img: "/files/obgImage-8320.jpg", span: "lg:col-span-12", h: "lg:min-h-[380px]", tag: "Visit us", d: "Fairoaks Airport, Chobham & the Glazing Studio at Longacres, Bagshot" },
  ],
  projectsKicker: "Recent installations",
  projectsTitle: "Case Studies.",
  newsKicker: "News · New location",
  newsTitle: "Glazing Studio opens at Longacres.",
  newsText: "Our brand-new Glazing Studio is now open at Longacres Garden Centre, Bagshot. Drop in while you shop, or book your appointment to discuss your project with the team.",
  newsImage: "",
  newsButton: { label: "Book your appointment", to: "/contact/" },
  manifestoKicker: "Why Cedar Views",
  manifestoTitle: "A £30,000 glazing project deserves more than a salesman's promise.",
  manifesto: [
    { icon: "Ruler", t: "Craftsmanship first", d: "Within the Cedar group, our team carries over 200 years of combined building and fenestration expertise. Every survey, every frame, every silicone bead is finished as if it were our own home." },
    { icon: "Award", t: "Only trusted brands", d: "Origin, Velfac, Rationel, Sunflex, Cortizo, Fortis, Residence. We only associate ourselves with manufacturers whose engineering matches our installation standards, with industry-leading guarantees." },
    { icon: "ShieldCheck", t: "Accountable end to end", d: "FENSA registered and locally rooted in Chobham. From design advice to installation and aftercare, one team is responsible for your project, and we answer the phone afterwards, too." },
  ],
  showroomKicker: "Fairoaks Airport, Chobham",
  showroomTitle: "See it. Touch it. Operate it.",
  showroomText: "Our flagship showroom displays sliding doors, bifolds, front doors and windows from every brand we work with, twenty minutes from Oxshott, Weybridge and Guildford. Bring your plans; leave with clarity.",
  showroomImage: "/images/showroom-hero.jpg",
};

export const SHOWROOM_PAGE = {
  heroImage: "/images/showroom-hero.jpg",
  heroOverline: "About us · Chobham & Bagshot",
  heroSub: "Two locations across Surrey. Meet the people behind the installations, on and off site.",
  introKicker: "Who we are",
  introTitle: "Experience you can walk into.",
  intro: [
    "Established in the rural backroads of Chobham, Cedar Views is the proud partner and flagship showroom of leading window and door brands, combining years of experience in fenestration and construction. Our installation teams work across Hampshire, Surrey, Berkshire, Twickenham, Richmond, Wimbledon and Chobham.",
    "On display are sliding doors, bifolding doors, front doors and windows from every brand we work with, including Origin, Sunflex UK, Velfac, Rationel, Residence and Fortis, across a wide range of designs and colour options. We know new glazing is a serious investment; our team will guide you through the options until the solution is unmistakably right for your home.",
    "And now there are two places to find us: our flagship showroom at Fairoaks Airport, Chobham, and our brand-new Glazing Studio at Longacres Garden Centre, Bagshot.",
  ],
  locationsTitle: "Two locations.",
  galleryTitle: "Walk the displays.",
  galleryLarge: ["/images/showroom-left.jpg", "/images/showroom-right.jpg"],
  galleryGrid: [IMG.fortisDetail, IMG.originInternal, "/sunflex-uk/files/small-1401.jpg", IMG.originFront],
  logosTitle: "Every brand, under one roof.",
};

export const CONTACT_PAGE = {
  overline: "Contact · Free, no-obligation quotations",
  title: "Contact",
  intro: "Tell us about your project and we'll respond within one working day, or call us directly and speak to the team.",
  formTitle: "Request your free quote",
};

export const TESTIMONIALS_PAGE = {
  heading: "Testimonials",
  title: "Word travels between homes.",
};

export const PRIVACY = {
  title: "Privacy Policy",
  paragraphs: [
    "Cedar Views respects your privacy. Any personal information you provide through this website, such as your name, email address, telephone number and postcode, is used solely to respond to your enquiry, prepare quotations and deliver our services.",
    "We do not sell or share your personal data with third parties for marketing purposes. Data submitted via our enquiry forms is transmitted securely and retained only as long as necessary to serve your enquiry and any subsequent project.",
    "You may request access to, correction of, or deletion of your personal data at any time by contacting us at info@cedarviews.co.uk or by calling 01483 920866.",
    "This website may use essential cookies to ensure correct operation. By using this site you consent to their use.",
    "Cedar Views, Unit E5B, Fairoaks Airport, Chobham, GU24 8HU.",
  ],
};

export const PROJECTS_PAGE = {
  heroImage: "/entrance-doors/kobbe-doors/files/obgImage-820.jpg",
  overline: "Portfolio",
  title: "Recent Work",
  sub: "Real installations across Surrey and Hampshire, every one surveyed, supplied and fitted by our own team.",
  galleryKicker: "The wider portfolio",
  galleryTitle: "Details from the field.",
  gallery: [
    "/origin/files/small-1348.jpg", "/files/obgImage-8189.jpg", "/sunflex-uk/files/small-1401.jpg", "/files/obgImage-8309.jpg",
    "/entrance-doors/composite-front-doors/files/obgImage-776.jpg", "/residence-collection/residence-7/files/obgImage-721.jpg",
    "/doors/internal-doors/files/obgImage-276.jpg", "/files/obgImage-8255.jpg", "/cortizo-bi-fold/files/obgImage-865.jpg",
    "/files/obgImage-8337.png", "/origin/files/small-708.jpg", "/files/obgImage-8222.jpg",
  ],
};
